<template>
<div id="ContainerEmployeeType">
       <h4 class="page-title text-truncate">
                {{$t('employeeType.EmplTypeTitle')}}          
        </h4>
  <div class="row">
              <div class="col-sm-12 col-md-3"  v-if="hasPermissionAdd()">                      
                    <MdButton
                      v-bind:Label="$t('employeeType.Add')" 
                      v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                      v-bind:IconClass="'ti-plus pr-1'"
                      v-on:click="AddEmployeeType"                   
                      v-bind:Name="'btn_add_EmployeeType'">
                    </MdButton>
                </div>
                <div v-bind:class="hasPermissionAdd() ? 'col-sm-12 col-md-9 mb-4':'col-sm-12 col-md-12 mb-4'">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input 
                              type="text" 
                              class="form-control"
                              :dir="dirInput"
                              v-model="parameter.SearchCriteria"
                              @keyup.enter="searchListing"
                            >
                            <div class="input-group-append">
                                <div class="input-group-append">
                                <MdButton
                                  v-bind:Name="'btnsearchinput'"
                                  v-bind:VariantProp="'btn btn-sm search-attached'"
                                  v-bind:IconClass="'mdi mdi-magnify'"
                                  v-on:click="searchListing">
                                </MdButton>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

      <div class="row">
        <div class="col-12 mt-2">
        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          <div class="row">
            <div class="col-md-12">
              <MdTable 
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:isReadOnly="false"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                :editIconEvent="EditEmployeeType"
                v-bind:VisibleEditIcon="hasPermissionEdit()"
                :deleteIconEvent="RemoveEmployeeType"
                v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                :onRowSelected="onRowSelected"
                :onFiltered="onFiltered"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction"
                :otherIcon="'printer-fill'"
                :otherIconEvent="showReport">
              </MdTable>
            </div>
          </div>
        </div>
      </div>
    
    <div class="space-actions"></div>
    <div class="page-actions">
      <MdButton
        v-bind:isReadOnly="items.length == 0"
        v-bind:Label="$t('Shared.Report')"
        v-bind:Name="'btnpatientlist'"
        v-bind:ClassProp="'secondary mx-2 btn-login'"
        v-on:click="showReport()"/>
    </div>

    <EmployeeTypeRep v-if="isReportVisible" 
      :closeWindow="closeParamRepWindow"
      :recNo="recNoToReport"
      :filterView="this.filterView"
      />

  </div>
</template>

<script>


import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import EmployeeTypeService from '@/services/employeetypes.service'
import Permission from '@/common/Permission'
//import { EventBus } from '../../../event-bus.js';
//import Utils from '@/common/utils'

export default {
  name: 'EmployeeTypeList',
 mixins: [ShowMessage, DBFunctions/*,EventBus*/,Permission],
  data(){
    return{
        OptionsRightMenu:{
          visible:false,
          ItemsList:[],
          btnvisible:false,
          itemdisabled: false,
          PatientCode:'',
          Mode:this.edit_mode,
          favButtonAtion:false          
        },

      isReportVisible: false,
      recNoToReport: null,
      parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0,         
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      ShowMessageIsEmpty:false,
      pageOptions: [5, 10, 15 ],
      items:[],
      filterView: false,
      fields: [
        { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'hidden'},       
        { key: 'description', sortable: true, label: this.$t('employeeType.EmplTypeTitle'), class: 'text-rigth' }, 
        { key: 'systemType', sortable: true, label: this.$t('employeeType.InternalType'), class: 'text-rigth' },
        { key: 'showInNotes', sortable: true, label: this.$t('employeeType.ShowInNotes'), class: 'text-rigth' },   
        { key: 'provider', sortable: true, label: this.$t('employeeType.IsProvider'), class: 'text-rigth' },   
        { key: 'nurse', sortable: true, label: this.$t('employeeType.IsNurse'), class: 'text-rigth' },   
        //{ key: 'showInEHR', sortable: true, label: this.$t('employeeType.ShowInEHRDashbaord'), class: 'text-rigth' },   
        //{ key: 'startPatientFlowInEHR', sortable: true, label: this.$t('employeeType.StartPatientFlowInEHRDashboard'), class: 'text-rigth' },   
      ],
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
  },

  methods:{

    searchListing(){
      this.currentPage = 1;
      this.SearchEmployeeType();
    },

    SearchEmployeeType(){

      this.$emit('load', true);
      this.parameter.PageNumber = this.currentPage;           
      this.parameter.PageSize = this.perPage;  
      this.parameter.SearchCriteria = this.parameter.SearchCriteria.trim();

      EmployeeTypeService.getAllEmployeeType(this.parameter)
        .then((response) => {
            if(response.status == '200' && response.data){
              this.items = response.data;                        
              let headerString = response.headers["x-pagination"];
              this.totalRows = JSON.parse(headerString).TotalCount;
            }               
            this.$emit('load', false);
        })
        .catch((error) => {                    
            this.$emit('load', false);            
            this.showResponseErrorMessage(error);
        }); 
    },

    AddEmployeeType(){
      this.emitDataforFavorites(); 
      this.$router.push({ name: "employeeType-add", params: {isSystemType: false }}).catch(()=>{});
    },

    EditEmployeeType(row){
      this.$router.push({ name: "employeeType-details", params: { id: row.code, isSystemType: row.isSystemType } });    
    },

    RemoveEmployeeType(row){
      const Id = row.code;
      this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_EmployeeType'
				})
          .then(value => {
            if(value){
              this.$emit('load', true);  
               EmployeeTypeService.DeleteEmployeeType(Id)
                .then(() => {
                  const index = this.items.findIndex(item => item.code === Id) 
                  if (~index) {
                    this.items.splice(index, 1) 
                    this.SearchEmployeeType(); 
                  }
                })
                .catch((error) => {
                  this.$emit('load', false);  
                  this.showResponseErrorMessage(error);           
                });
            }
          })
    },

    
    onRowSelected() {    
   
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },

    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },

    selectThirdRow() {
      this.$refs.selectableTable.selectRow(2)
    },

    unselectThirdRow() {
      this.$refs.selectableTable.unselectRow(2)
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    pageChanged(page){
      this.currentPage = page;    
      this.SearchEmployeeType();  
    },
    
    PerPageFunction(perpage){
      this.perPage = perpage;  
      this.currentPage = 1;
      this.SearchEmployeeType();  
    },
    
    showReport(item) {
      if(this.items.length > 0){
        if (item && item.code) {
          this.recNoToReport = item.code
        }
        this.isReportVisible = true
      } else {
        setTimeout(() => 
          this.$bvToast.toast(this.$t('MdTable.nRecShow'), {
            title:  this.$t('Msg.Info'),
            autoHideDelay: 3000,
            variant: "info"
          }),
        50);
      }
    },

    closeParamRepWindow() {
      this.isReportVisible = false
      this.recNoToReport = null
    },
  },

  mounted(){
      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
      case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      case 'L1R0':
      case 'L1R1':
          this.OptionsRightMenu.btnvisible = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      default:
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }

    this.SearchEmployeeType();
  
  },

    destroyed(){
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false; 
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
   
};
</script>


